import styled from 'styled-components';

export const TextBold = styled.div`
    font-family: AvenirNextWorld Bold;
    font-size: ${(props) => props.fontSize};
`;
export const TextRegular = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: ${(props) => props.fontSize};
`;
export const TextDemi = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: ${(props) => props.fontSize};
    margin: ${(props) => props.margin};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Navigation = styled.div`
    height: 31px;
    /* background-color: burlywood; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const TimelineHeaderDatePicker = styled.div`
    width: 265px;
    font-family: AvenirNextWorld Bold;
    font-size: 18px;
    height: 100;
    /* background-color: white; */
    display: flex;
    flex-direction: row;
`;

export const NavArrow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const DateRangeIndicator = styled.div`
    margin: 0 10px 0 10px;
    padding: 2px 0 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TimelineHeaderCaseCount = styled.div`
    height: 100%;
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    /* background-color: white; */
    margin-right: 32px;
`;

export const TimelineHeader = styled.div`
    height: 100%;
    width: 369px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* background-color: beige; */
`;
